import { css } from "lit";
import { Style } from "../Styles";

export const styles = css`
    ${Style}
    :host {
        display: block;
    }

    .container {
        gap: 0.5em;
    }

    .button-row {
        justify-content: space-between;
    }

    .entry {
        gap: 0.25em;
        padding: 0.5em;
        border-top: var(--ds-border);
    }

    .entry.active {
        background-color: var(--accent-color);
        color: white;
    }

    .entry h3 {
        margin: 0;
    }

    .entry span {
        font-size: 1em;
    }

    sl-menu {
        background-color: white;
    }

    sl-button {
        width: 100%;
    }
`;
